// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Qs-z","tooltipWrapper":"Rs-z","icon":"Ss-z","tooltip":"Ts-z","content":"Us-z"};